<template>
  <div class="notebook-detail">
    <div class="title-box primary-box">
      <h2>{{ notebook?.name ?? "" }}</h2>
    </div>
    <NoteFolder 
        v-if="!!notebook" 
        :note-folder="notebook" 
        :notebook-id="notebook.id"
        @folderCreated="fetchNotebook"
        
    />
    
  </div>
</template>
<script>
import {updateMetaInfo} from "@/middleware/metaUpdater";
import {getTranslation} from "@/services/stringTableService";
import NoteFolder from "@/components/NoteFolder.vue";

export default {
  computed: {
    notebook() {
      return this.$store.state.selectedMainFolder;
    }
  },
  components: {NoteFolder},
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      language: "IT"
    }
  },
  mounted() {
    this.fetchNotebook();
  },
  methods: {
    async fetchNotebook() {
      try {
        this.$store.dispatch('setLoading', true);
        await this.$store.dispatch('updateSelectedMainFolder', this.id);
      } catch (error) {
        console.error("Error fetching notebook:", error);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    getTranslation(key) {
      return getTranslation(this.language, key);
    }
  },
  watch: {
    notebook() {
      if(this.notebook) {
        updateMetaInfo({
          title: (this.notebook.name ?? "Notebook") + " - Cinopedia"
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "../style/_variables.scss";
.notebook-detail {
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

</style>